import { SerializableObject } from '../../../../../legacy/objects/generic/serialization/serializable-object';

import { SearchExperienceConfigSchema } from './search-experience-config-schema';

export class SearchExperienceConfig extends SerializableObject {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected enabled!: boolean;

  /////////////////////////////////////////////////////////////////////////////
  // Get Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): SearchExperienceConfigSchema {
    return new SearchExperienceConfigSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(SearchExperienceConfig.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  protected static _deserialize(validationResult: import('joi').ValidationResult): SearchExperienceConfig {
    return new SearchExperienceConfig(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getEnabled(): boolean {
    return this.enabled;
  }
}
